import React, { lazy, useContext, useEffect, useState, Suspense } from 'react';
import { Modal, Row, Col, Button, Spin, Card, Icon } from 'antd';
import { DelContext } from '../../context/Deliveries/DeliveriesContext';
import { PoContext } from '../../context/PurchaseOrder/PurchaseOrderContext';

const PoDeliveredTable = lazy(() => import('./PoDeliveredTable'));
const PoDeliveredItemForm = lazy(() => import('./PoDeliveredItemForm'));

const modalStyles = `
@keyframes icon-float {
  0%, 100% { transform: translateY(0px); }
  50%       { transform: translateY(-4px); }
}
@keyframes icon-beat {
  0%, 100% { transform: scale(1); }
  50%       { transform: scale(1.22); }
}
@keyframes icon-shake {
  0%, 100% { transform: rotate(0deg); }
  20%       { transform: rotate(-14deg); }
  40%       { transform: rotate(14deg); }
  60%       { transform: rotate(-8deg); }
  80%       { transform: rotate(8deg); }
}
@keyframes icon-bounce {
  0%, 100% { transform: translateY(0px) scaleY(1); }
  40%       { transform: translateY(-5px) scaleY(1.05); }
  70%       { transform: translateY(2px) scaleY(0.96); }
}
@keyframes glow-ring {
  0%, 100% { box-shadow: 0 0 0 0 var(--glow-color, rgba(24,144,255,0.35)); }
  50%       { box-shadow: 0 0 0 8px rgba(0,0,0,0); }
}
@keyframes modalSlideIn {
  from {
    opacity: 0;
    transform: translateY(30px) scale(0.96);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

@keyframes shimmer {
  0% { background-position: -1000px 0; }
  100% { background-position: 1000px 0; }
}

@keyframes slideInLeft {
  from {
    opacity: 0;
    transform: translateX(-20px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

/* Modal Container */
.po-delivered-modal .ant-modal-content {
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 20px 40px rgba(0,0,0,0.12), 0 8px 16px rgba(0,0,0,0.08);
  animation: modalSlideIn 0.3s cubic-bezier(0.34, 1.2, 0.64, 1);
}

.po-delivered-modal .ant-modal-header {
  background: linear-gradient(135deg, #003a8c 0%, #0050b3 35%, #1890ff 70%, #096dd9 100%);
  border-bottom: none;
  padding: 20px 24px;
  position: relative;
  overflow: hidden;
}

.po-delivered-modal .ant-modal-header::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 3px;
  background: linear-gradient(90deg, #13c2c2, #1890ff, #722ed1, #eb2f96, #13c2c2);
  background-size: 300% auto;
  animation: shimmer 3s linear infinite;
}

.po-delivered-modal .ant-modal-header::after {
  content: '';
  position: absolute;
  inset: 0;
  background-image: radial-gradient(rgba(255,255,255,0.1) 1px, transparent 1px);
  background-size: 20px 20px;
  pointer-events: none;
}

.po-delivered-modal .ant-modal-title {
  font-size: 18px;
  font-weight: 700;
  color: #fff;
  letter-spacing: 0.5px;
  text-shadow: 0 1px 2px rgba(0,0,0,0.1);
  display: flex;
  align-items: center;
  gap: 10px;
}

.po-delivered-modal .ant-modal-title::before {
  content: '📦';
  font-size: 20px;
  filter: drop-shadow(0 2px 4px rgba(0,0,0,0.2));
}

.po-delivered-modal .ant-modal-close {
  color: rgba(255,255,255,0.8);
  top: 18px;
  right: 20px;
  transition: all 0.3s ease;
}

.po-delivered-modal .ant-modal-close:hover {
  color: #fff;
  transform: rotate(90deg) scale(1.1);
}

.po-delivered-modal .ant-modal-body {
  padding: 24px;
  background: #f0f2f5;
}

/* Button Styling */
.po-delivered-modal .btn-add-delivery {
  background: linear-gradient(135deg, #003a8c 0%, #0050b3 35%, #1890ff 70%, #096dd9 100%);
  border: none;
  border-radius: 10px;
  padding: 8px 20px;
  height: auto;
  font-weight: 600;
  box-shadow: 0 4px 12px rgba(24,144,255,0.3);
  transition: all 0.3s ease;
}

.po-delivered-modal .btn-add-delivery:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(24,144,255,0.4);
  background: linear-gradient(135deg, #0050b3 0%, #1890ff 100%);
}

.po-delivered-modal .btn-add-delivery .anticon {
  font-size: 14px;
}

.po-delivered-modal .btn-close-form {
  background: linear-gradient(135deg, #003a8c 0%, #0050b3 35%, #1890ff 70%, #096dd9 100%);
  border: none;
  border-radius: 10px;
  padding: 8px 20px;
  height: auto;
  font-weight: 600;
  color: #fff;
  box-shadow: 0 4px 12px rgba(24,144,255,0.3);
  transition: all 0.3s ease;
}

.po-delivered-modal .btn-close-form:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(24,144,255,0.4);
  color: #fff;
  background: linear-gradient(135deg, #0050b3 0%, #1890ff 100%);
}

.po-delivered-modal .btn-close-form .anticon {
  font-size: 14px;
}

/* Spin Loading Custom */
.po-delivered-modal .ant-spin-container {
  transition: all 0.3s ease;
}

.po-delivered-modal .ant-spin-spinning {
  max-height: none;
}

.po-delivered-modal .ant-spin-dot {
  color: #1890ff;
}

/* Responsive */
@media (max-width: 768px) {
  .po-delivered-modal {
    width: 95% !important;
  }
  
  .po-delivered-modal .ant-modal-body {
    padding: 16px;
  }
}

/* Form Side Panel Animation */
.po-delivered-form-enter {
  animation: slideInLeft 0.3s ease;
}

/* Stat Cards */
.delivery-stat-card {
  border-radius: 10px !important;
  box-shadow: 0 2px 12px rgba(24,144,255,0.08) !important;
  border: 1px solid #e6f0ff !important;
  background: #fff !important;
  transition: all 0.3s ease !important;
}

.delivery-stat-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(24,144,255,0.12) !important;
}
`;

const PoViewDeliveredItem = (props) => {
  const { itemDeliveryDetails: { visible, id }, setItemDeliveryDetails } = props;
  const {
    deliveries,
    getItemDeliveries,
    userDetails,
    addItemDelivery,
    editItemDelivery,
    deleteDelivery,
    resetDeliveryDetails
  } = useContext(DelContext);
  const { updatePoItem } = useContext(PoContext);
  const [formConfig, setFormConfig] = useState({ visible: false });
  const [isLoading, setLoading] = useState(false);
  
  useEffect(() => {
    setLoading(true);
    getItemDeliveries(id)
      .finally(() => setLoading(false));
  }, []);

  const {
    itemDeliveryDetails: {
      itemQuantity,
      itemDelivered,
      itemRemaining,
      item_id,
      itemDeliveries
    }
  } = deliveries;

  return (
    <>
      <style>{modalStyles}</style>
      <Modal
        className="po-delivered-modal"
        title="Delivery Details"
        footer={null}
        width={formConfig.visible ? "85%" : "65%"}
        style={{ top: 20 }}
        visible={visible}
        onCancel={() => {
          if (!isLoading) {
            setItemDeliveryDetails({ visible: false });
            resetDeliveryDetails();
          }
        }}
      >
        <Spin spinning={isLoading}>
          <Row gutter={24}>
            <Col 
              style={{ display: formConfig.visible ? 'block' : 'none' }} 
              lg={{ span: 7 }}
              className="po-delivered-form-enter"
            >
              <Suspense fallback={<div style={{ padding: 20, textAlign: 'center' }}>Loading form...</div>}>
                <PoDeliveredItemForm
                  setFormConfig={setFormConfig}
                  updatePoItem={updatePoItem}
                  addItemDelivery={addItemDelivery}
                  editItemDelivery={editItemDelivery}
                  userType={userDetails.type}
                  details={{ ...formConfig.details }}
                />
              </Suspense>
            </Col>
            <Col lg={{ span: formConfig.visible ? 17 : 24 }}>
              {/* REPLACED: Stat Cards instead of Descriptions */}
              <Row gutter={[16, 16]} style={{ marginBottom: 20 }}>
                <Col xs={24} sm={8}>
                  <Card className="delivery-stat-card" bodyStyle={{ padding: '18px 20px' }} bordered={false}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 14 }}>
                      <div className="mat-glow icon-float" style={{
                        width: 46, height: 46, borderRadius: 12, background: '#e6f7ff',
                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                        '--glow-color': 'rgba(24,144,255,0.3)'
                      }}>
                        <Icon type="shopping-cart" style={{ fontSize: 18, color: '#1890ff' }} />
                      </div>
                      <div>
                        <div style={{ fontSize: 11, color: '#8c8c8c', fontWeight: 500, letterSpacing: '0.3px' }}>
                          TOTAL QUANTITY
                        </div>
                        <div style={{ fontSize: 22, fontWeight: 700, color: '#1890ff', lineHeight: 1.2 }}>
                          {itemQuantity}
                        </div>
                      </div>
                    </div>
                  </Card>
                </Col>
                <Col xs={24} sm={8}>
                  <Card className="delivery-stat-card" bodyStyle={{ padding: '18px 20px' }} bordered={false}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 14 }}>
                      <div className="mat-glow icon-beat" style={{
                        width: 46, height: 46, borderRadius: 12, background: '#e6fffb',
                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                        '--glow-color': 'rgba(19,194,194,0.3)'
                      }}>
                        <Icon type="check-circle" style={{ fontSize: 18, color: '#13c2c2' }} />
                      </div>
                      <div>
                        <div style={{ fontSize: 11, color: '#8c8c8c', fontWeight: 500, letterSpacing: '0.3px' }}>
                          TOTAL DELIVERED
                        </div>
                        <div style={{ fontSize: 22, fontWeight: 700, color: '#13c2c2', lineHeight: 1.2 }}>
                          {itemDelivered}
                        </div>
                      </div>
                    </div>
                  </Card>
                </Col>
                <Col xs={24} sm={8}>
                  <Card className="delivery-stat-card" bodyStyle={{ padding: '18px 20px' }} bordered={false}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 14 }}>
                      <div className={`mat-glow ${itemRemaining > 0 ? 'icon-shake' : 'icon-bounce'}`} style={{
                        width: 46, height: 46, borderRadius: 12, 
                        background: itemRemaining > 0 ? '#fff1f0' : '#f6ffed',
                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                        '--glow-color': itemRemaining > 0 ? 'rgba(255,77,79,0.3)' : 'rgba(82,196,26,0.3)'
                      }}>
                        <Icon type="clock-circle" style={{ fontSize: 18, color: itemRemaining > 0 ? '#ff4d4f' : '#52c41a' }} />
                      </div>
                      <div>
                        <div style={{ fontSize: 11, color: '#8c8c8c', fontWeight: 500, letterSpacing: '0.3px' }}>
                          TOTAL REMAINING
                        </div>
                        <div style={{ fontSize: 22, fontWeight: 700, color: itemRemaining > 0 ? '#ff4d4f' : '#52c41a', lineHeight: 1.2 }}>
                          {itemRemaining}
                        </div>
                      </div>
                    </div>
                  </Card>
                </Col>
              </Row>
              
              {!formConfig.visible ? (
                itemRemaining !== 0 && (
                  <Button
                    onClick={() => setFormConfig({ visible: true, details: { itemRemaining, item_id } })}
                    style={{ marginBottom: 16 }}
                    className="btn-add-delivery"
                    icon="plus"
                    type="primary"
                  >
                    Add Delivery
                  </Button>
                )
              ) : (
                <Button
                  onClick={() => setFormConfig({ visible: false })}
                  style={{ marginBottom: 16 }}
                  className="btn-close-form"
                  icon="close"
                >
                  Close Form
                </Button>
              )}
              
              <Suspense fallback={<div style={{ padding: 40, textAlign: 'center' }}>Loading table...</div>}>
                <PoDeliveredTable
                  onRowClick={setFormConfig}
                  itemDeliveries={itemDeliveries}
                  details={deliveries.itemDeliveryDetails}
                  deleteDelivery={deleteDelivery}
                  setFormConfig={setFormConfig}
                  updatePoItem={updatePoItem}
                  userType={userDetails.type}
                />
              </Suspense>
            </Col>
          </Row>
        </Spin>
      </Modal>
    </>
  );
}

export default PoViewDeliveredItem;